module.exports = __webpack_public_path__ + "static/media/YDCM.3eaaf056.pdf";